import React, { useEffect, useState } from 'react';
import "./NewCampaign.css";
import { CampaignPaymentMethod } from "@/data/types";
import {
  AndroidIcon,
  AppleIcon,
  AppStoreIconDefault,
  CheckMark,
  GooglePlayIconDefault,
  WebPageIconDefault,
  GoBackIcon, CopyIcon
} from "@/react_app/img/Icons";
import { Divider } from "primereact/divider";
import { Image } from "primereact/image";
import { useBrands } from "@/modules";
import { useContentItems } from "@/modules";
import NewContentListItem from "../NewLatestItems/NewContentListItem/NewContentListItem"
import { calculateCpiRate } from "@/utils/globals/cpi-rate";

export function OtherUrlIcon(props) {
  return (
    <div>
      {props.index === 0 && <GooglePlayIconDefault />}
      {props.index === 1 && <AppStoreIconDefault />}
      {props.index > 1 && <WebPageIconDefault />}
    </div>
  )
}

const getUrlName = (index) => {
  if (index === 0) {
    return 'Google Play Link';
  } else if (index === 1) {
    return 'Apple App Store Link';
  }
  return 'Product Website Link';
}

export default function(props) {
  const [filteredAttachments, setFilteredAttachments] = useState([]);
  const [brand, setBrand] = useState('');
  const [content, setContent] = useState([]);

  const brands = useBrands();
  const contentItems = useContentItems();

  useEffect(() => {
    if(props.campaign) {
      setFilteredAttachments(props.campaign.attachments.filter(file => file.type?.startsWith('image/')));
      brands.manager.loadBrand(props.campaign.brand.id).then((result) => {
        setBrand(result);
      });
      contentItems.list.loadContentItems(props.campaign.id).then((result) => {
        setContent(result);
      });
    }
  }, [props.campaign]);

  const goToUrl = (url) => {
    window.open(url, '_blank').focus();
  }

  const copyUrl = (url) => {
    navigator.clipboard.writeText(url);
  };

  return (
    <div className={'campaign-page'}>
      <div className={'goBack'} onClick={() => props.handleBackToAll()}>
        <GoBackIcon/>
        <span className={'goBackLabel'}>All Campaigns</span>
      </div>
      <div className={'campaignDetails'}>
        <div className={'coverBackground'} style={{ background: `linear-gradient(rgba(19, 10, 35, 0.7), rgba(19, 10, 35, 0.7)), url(${props.campaign?.photo})` }}>
          <p className={'coverTitle'}>{props.campaign?.name}</p>
          <div className={'coverGrid'}>
            <div>
              <p className={'coverLabel'}>Category:</p>
              <p className={'coverValue'}>{props.campaign?.targetMarket.title}</p>
            </div>
            <div>
              <p className={'coverLabel'}>Campaign {props.campaign?.paymentMethod}:</p>
              {props.campaign?.paymentMethod === CampaignPaymentMethod.CPC &&
                <p className={'coverValue'}>{calculateCpiRate(props.campaign?.cpc.amount, props.campaign?.appliedFee)}</p>
              }
              {props.campaign?.paymentMethod === CampaignPaymentMethod.CPM &&
                <p className={'coverValue'}>{calculateCpiRate(props.campaign?.cpm.amount, props.campaign?.appliedFee)}</p>
              }
              {props.campaign?.paymentMethod === CampaignPaymentMethod.CPI &&
                <div>
                  <div className={'coverValue'}>
                    <AndroidIcon/>
                    {calculateCpiRate(props.campaign?.cpi.android.amount, props.campaign?.appliedFee)}{' '}
                    {props.campaign?.cpi.android.currency}
                  </div>
                  <div className={'coverValue'}>
                    <AppleIcon/>
                    {calculateCpiRate(props.campaign?.cpi.ios.amount, props.campaign?.appliedFee)}{' '}
                    {props.campaign?.cpi.ios.currency}
                  </div>
                </div>
              }
            </div>
            <div>
              <p className={'coverLabel'}>Application time left:</p>
              <p className={'coverValue'}>{props.campaign?.dates.endDate ? new Date(props.campaign.dates.endDate).toLocaleDateString
              ('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Until budget is complete'}</p>
            </div>
            <div>
              <p className={'coverLabel'}>Region:</p>
              <p className={'coverValue'}>{props.campaign?.desiredRegions[0]?.value}</p>
            </div>
          </div>
          <div className={'coverStatus'}>
            {props.campaign?.status}
          </div>
        </div>
        <div className={'infoMain'}>
          <div className={'infoMainLeft'}>
            <div>
              <p className={'infoLabel'}>Campaign Details</p>
              <p className={'infoText'}>{props.campaign?.productName}</p>
            </div>
            <div>
              <p className={'infoLabel'}>Talking points</p>
              <div className={'talkingPointsWrapper'}>
                {props.campaign?.talkingPoints?.filter(item => item !== '').map((item, index) =>
                  <div key={index} className={'talkingPoint'}>
                    <CheckMark />
                    <div className={'talkingPointText'}>
                      {item}
                    </div>
                  </div>)}
              </div>
            </div>
          </div>
          <div className={'infoMainRight'}>
            <div>
              <p className={'infoLabel'}>Campaign URls</p>
              <div className={'linkWrapper'}>
                {props.campaign?.productUrls?.map((item, index) =>
                  <div key={index}>
                    <p className={'linkLabel'}>{getUrlName(index)}</p>
                    <div className={'link'}>
                      <OtherUrlIcon index={index}/>
                      <span className={'overflowEllipsis'} onClick={() => goToUrl(item.value)}>{item.value}</span>
                      {item.value && <CopyIcon onClick={() => copyUrl(item.value)}/>}
                    </div>
                  </div>)}
              </div>
            </div>
            <div>
              <p className={'infoLabel'}>Call to Action</p>
              <div className={'callToActionBox'}>{props.campaign?.callToAction}</div>
            </div>
            <div>
              <p className={'infoLabel'}>Attachments</p>
              <div className={'attachmentsWrapper'}>
                {filteredAttachments.slice(0,3).map((item, index) =>
                  <Image key={index} src={item.objectURL} alt={'attachment image'} className={'attachmentImage'}/>)}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Divider className={'divider'}/>
      <div className={'overviewBottom'}>
        <div className={'overviewBottomLeft'}>
          <p className={'overviewLabel'}>About Brand</p>
          <div className={'brandPhotoRow'}>
            <Image src={brand?.photo} alt={'brand photo'} className={'brandPhoto'}/>
            <span>{brand?.name}</span>
          </div>
          <p className={'overviewText'}>{brand?.description}</p>
        </div>
        <div className={'overviewBottomRight'}>
          <div className={'contentItemsTopRow'}>
            <p className={'overviewLabel'}>Content</p>
            <span className={'seeAll'} onClick={() => props.handleRoutingAll()}>See All</span>
          </div>
          <div className={'contentItemsWrapper'}>
            {content.slice(0,4).map((item, index) =>
              <div key={index} className={'contentItem'}>
                <NewContentListItem item={item} handleRouting={() => props.handleContentRouting(item.id)}/>
              </div>)}
          </div>
        </div>
      </div>
    </div>
  )
}
